import { createSvgElement } from '@ardoq/dom-utils';
import {
  type Constructor,
  IEdge,
  type ILabel,
  type IRenderContext,
  LabelStyleBase,
  Rect,
  Size,
  type Visual,
} from '@ardoq/yfiles';
import { LabelExportSupport } from '../lookupMethods';
import { GraphItem } from '../graphItems/GraphItem';
import { measureNodeLabel } from '@ardoq/graph-labeling';
import { MODERNIZED_BLOCK_DIAGRAM_BADGE_HEIGHT as BADGE_HEIGHT } from '../visuals/consts';
import { DescendantCountLabelVisual } from './DescendantCountLabelVisual';

const BADGE_ENDCAP_WIDTH = 6;

class DescendantCountLabelStyle extends LabelStyleBase {
  static Instance = new DescendantCountLabelStyle();
  private constructor() {
    super();
  }
  override createVisual(
    _context: IRenderContext,
    {
      text,
      owner,
      layout: {
        bounds: { x, y },
      },
    }: ILabel
  ): Visual | null {
    const container = createSvgElement('g');
    const isTransparentized = Boolean(
      (owner?.tag as GraphItem | null)?.isTransparentized
    );
    container.style.opacity = isTransparentized ? '0.32' : '1';
    const isEdge = owner instanceof IEdge;
    const width = Math.max(
      BADGE_HEIGHT,
      measureNodeLabel(text) + 2 * BADGE_ENDCAP_WIDTH
    );
    const left = x + (isEdge ? -width / 2 : -width);
    const top = y + (isEdge ? -BADGE_HEIGHT / 2 : 0);
    const bounds = new Rect(left, top, width, BADGE_HEIGHT);
    return new DescendantCountLabelVisual(text, bounds, isTransparentized);
  }
  override getPreferredSize(_: ILabel): Size {
    return Size.ZERO;
  }

  protected override lookup(_label: ILabel, type: Constructor): any {
    // Exclude descendant count labels from export by returning empty array
    if (type === LabelExportSupport) {
      return {
        toJSON: () => [],
      } satisfies LabelExportSupport;
    }
    return super.lookup(_label, type);
  }
}
export { DescendantCountLabelStyle };
